import api from '@/services/api-service';
import RestResource from '@/services/resources/restResource';

export class ShippingMethodsApi extends RestResource {
    /**
     *
     * @param {ApiClient} apiClient
     * @param {string} endpoint
     */
    constructor(apiClient, endpoint = 'shippingMethods') {
        super(apiClient, endpoint);
    }

    getAll() {
        return this.find();
    }

    getHazmatShippingMethods(payload) {
        return this.api.post(`${this.endpoint}/hazmatShippingMethods`, payload);
    }
}

export default new ShippingMethodsApi(api);
